import InputText, { InputType } from 'bloko/blocks/inputText';

import useTrls from 'hooks/translation/useTrls';

import ClickmeFormItem from 'components/ClickmeFormItem';

import { setPayerKPP } from 'store/models/payerCreate';
import { useDispatch, useSelector } from 'store/utils';

const PayerKPP = () => {
    const dispatch = useDispatch();
    const { payerKPP, payerErrors } = useSelector((state) => state.payerCreate);
    const trl = useTrls();

    return (
        <ClickmeFormItem
            input={
                <InputText
                    type={InputType.Number}
                    value={payerKPP}
                    onChange={(value) => dispatch(setPayerKPP(value))}
                    placeholder={trl('InvoiceAndPayerForm.PayerCreate.PayerKPP.placeholder')}
                    invalid={Boolean(payerErrors.kpp)}
                    data-qa="kpp"
                />
            }
            legend={trl('InvoiceAndPayerForm.PayerCreate.PayerKPP.legend')}
            hint={trl('InvoiceAndPayerForm.PayerCreate.PayerKPP.hint')}
            isRequired
            error={payerErrors.kpp}
        />
    );
};

export default PayerKPP;
